import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import '../styles/zelements.less';
class ZInput extends React.Component {
  static propTypes = {
    classNames: PropTypes.string,
    password: PropTypes.bool,
    errorMessageVisible: PropTypes.bool,
    customError: PropTypes.string,
    customErrorMarkup: PropTypes.element,
    error: PropTypes.string,
    onChange: PropTypes.func,
    validators: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };
  static defaultProps = {
    validators: {},
    value: null,
  };

  state = {
    value: '',
    pristine: true,
    invalidOverride: false,
  };

  componentDidMount() {
    let self = this;
    this.refs.input.addEventListener('invalid', function(e) {
      self.setState({ pristine: false });
      e.preventDefault();
    });
  }

  getValue() {
    return this.state.value;
  }

  setToDirty() {
    this.setState({ pristine: false });
  }
  resetToPristine() {
    this.setState({ pristine: true, value: '' });
    this.refs.input.value = '';
  }
  invalidate() {
    this.setState({ invalidOverride: true });
  }
  passCustomValidity(str) {
    this.refs.input.setCustomValidity(str);
  }

  _onChange() {
    this.setState({ pristine: false, invalidOverride: false });
  }

  render() {
    let containerClasses = classNames(this.props.classNames, 'input-container');
    let errorFromValidator = Object.values({ ...this.props.validators })
      .map(f => f(this.props.value))
      .filter(v => v)[0];
    let error = (() => {
      if (this.state.pristine || !this.props.errorMessageVisible) return null;
      else if (this.props.customError) return this.props.customError;
      else if (this.refs.input && !this.refs.input.validity.valid)
        return this.props.error;
      else if (errorFromValidator) return errorFromValidator;
      else if (this.props.customErrorMarkup)
        return this.props.customErrorMarkup;
    })();
    let inputClasses = classNames({
      password: this.props.password,
      pristine: this.state.pristine,
      valid: !error,
      invalid: !!error,
    });
    const inputProps = _.omit(
      this.props,
      'valueLink',
      'password',
      'classNames',
      'errorMessageVisible',
      'customError',
      'onChange',
      'customErrorMarkup'
    );
    return (
      <div className={containerClasses}>
        <input
          {...inputProps}
          ref="input"
          className={inputClasses}
          onChange={e => {
            this._onChange();
            if (this.props.onChange) this.props.onChange(e);
          }}
        />
        {error ? (
          <div className="error-msg">
            <img className="error-img" src={require('../images/invalid.svg')} />
            {error}
          </div>
        ) : (
          <span />
        )}
      </div>
    );
  }
}

export { ZInput };



// WEBPACK FOOTER //
// ./js/components/widgets/ZElements.js